export default function RightArrow(props: any) {
  const { className, style, onClick } = props;

  return (
    <button
      type="button"
      data-role="none"
      className={className}
      style={{ display: " block", ...style }}
      onClick={onClick}
    >
      <svg
        width="31"
        height="31"
        viewBox="0 0 31 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.3868 30.7736C23.8847 30.7736 30.7736 23.8847 30.7736 15.3868C30.7736 6.88891 23.8847 0 15.3868 0C6.88891 0 0 6.88891 0 15.3868C0 23.8847 6.88891 30.7736 15.3868 30.7736Z"
          fill="#E2EAF8"
        />
        <path
          d="M13.0154 18.8323L16.453 15.3872L13.0154 11.942L14.0737 10.8837L18.5772 15.3872L14.0737 19.8906L13.0154 18.8323Z"
          fill="#626262"
        />
      </svg>
    </button>
  );
}
